<template>
  <v-dialog
    v-model="isActive"
    :max-width="290"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="fromDbTime(value)"
        :prepend-icon="icon"
        readonly
        :disabled="disabled"
        :rules="rules"
        :error-messages="errorMessages"
        :required="required"
        size="3"
        v-on="on"
      />
    </template>
    <v-time-picker
      :value="fromDbTime(value)"
      :allowed-minutes="allowedMinutes"
      :allowed-hours="allowedHours"
      ampm-in-title
      scrollable
      actions
      @input="set($event)"
    >
      <v-spacer />
      <v-btn
        text
        color="error"
        @click="resetToOrig"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="closePicker"
      >
        Done
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimePicker',

  props: {
    display: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    value: String,
    label: String,
    rules: {
      type: Array,
      default () {return []}
    },
    errorMessages: {
      type: Array,
      default () {return []}
    },
    icon: {
      type: String,
      default: 'mdi-clock-outline'
    },
    minInterval: Number,
    allowedMinutes: {
      type: [Function],
      default () {
        return (val) => {
          if (!this.minInterval) return true
          return val % this.minInterval === 0
        }
      }
    },
    hourInterval: Number,
    allowedHours: {
      type: [Function],
      default () {
        return (val) => {
          if (!this.hourInterval) return true
          return val % this.hourInterval === 0
        }
      }
    },
    required: Boolean
  },

  data: function () {
    return {
      isActive: false,
      origVal: null
    }
  },

  watch: {
    display (val) {
      if (this.readonly || this.disabled || this.isActive === val) return
      this.isActive = val
    },
    disabled (val) {
      if (val) {
        this.isActive = false
      }
    },
    isActive (val) {
      if (!val) return
      this.origVal = this.value
    }
  },

  mounted () {
    this.isActive = !this.readonly && !this.disabled && !!this.display
  },

  methods: {
    closePicker () {
      this.isActive = false
    },
    resetToOrig () {
      this.$emit('input', this.origVal)
      this.closePicker()
    },
    set (pickerTime) {
      return this.$emit('input', this.toDbTime(pickerTime))
    },
    fromDbTime (dbTime) {
      if (!dbTime) return null
      return moment(dbTime, 'HH:mm:ss').format('hh:mma')
    },
    toDbTime (pickerTime) {
      if (!pickerTime) return null
      return moment(pickerTime, 'hh:mma').format('HH:mm:ss')
    }
  }
}
</script>
